export default [
  {
    type: 'section',
    title: 'Informasi Brand',
    description: 'Isi informasi brand untuk ditampilkan di aplikasi.',
  },
  {
    key: 'media_id',
    image: 'image',
    label: 'Foto Brand',
    type: 'image',
    required: true,
  },
  {
    key: 'name',
    label: 'Nama',
    required: true,
    maxLength: 255,
  },
  {
    key: 'email',
    label: 'Email',
    type: 'email',
    required: true,
  },
  {
    key: 'phone',
    label: 'Nomor HP',
    maxLength: 30,
    type: 'phone',
    notes: 'Contoh: +6281234567890 (format: +62/0 diikuti 6-15 digit)',
  },
  {
    key: 'password',
    label: 'Password',
    type: 'password',
    required: true,
    minLength: 8,
    notes: 'Minimal 8 karakter dengan kombinasi huruf dan angka.',
    visibility: {
      // Show password only on create form
      callback: (fields, ctx) => ctx && ctx.create === true,
    },
  },
  {
    key: 'description',
    label: 'Deskripsi',
    type: 'textarea',
    rows: 4,
  },
  {
    key: 'affiliate_percentage',
    label: 'Affiliate %',
    type: 'number',
    min: 0,
    max: 100,
    notes: 'Persentase komisi affiliate. 0-100%.',
  },
  {
    key: 'order',
    label: 'Urutan',
    type: 'number',
    min: 0,
    notes: [
      'Dapat digunakan untuk promosi.',
    ],
  },
  {
    key: 'is_active',
    label: 'Status',
    type: 'radio',
    value: true,
    options: [
      { value: true, text: 'Aktif' },
      { value: false, text: 'Tidak Aktif' },
    ],
  },
  {
    key: 'is_open',
    label: 'Toko',
    type: 'radio',
    required: true,
    value: true,
    options: [
      { value: true, text: 'Buka' },
      { value: false, text: 'Tutup' },
    ],
  },
  {
    key: 'close_desc',
    label: 'Keterangan Tutup',
    type: 'textarea',
    rows: 3,
    required: true,
    visibility: {
      callback: fields => (fields.find(f => f.key === 'is_open') || {}).value === false,
    },
  },
  {
    key: 'close_started_at',
    label: 'Mulai Tutup',
    type: 'datetime',
    visibility: {
      callback: fields => (fields.find(f => f.key === 'is_open') || {}).value === false,
    },
  },
  {
    key: 'close_ended_at',
    label: 'Akhir Tutup',
    type: 'datetime',
    visibility: {
      callback: fields => (fields.find(f => f.key === 'is_open') || {}).value === false,
    },
  },
]
